import { RollTos } from "@/constants";
import type { RollTo } from "@/types";
import { create } from "zustand";
import { persist } from "zustand/middleware";

type DiceRollPrivacy = {
  rollTo?: RollTo;
  hasSeenDiceContainer?: boolean;
};
type DiceRollPrivacyState = {
  [userId: number]: DiceRollPrivacy;
  getDiceRollPrivacy: (userId: number) => DiceRollPrivacy | undefined;
  setRollToPrivacy: (userId: number, migrationValue?: RollTo) => void;
  setHasSeenDiceContainer: (userId: number) => void;
};

export const diceRollPrivacyFns: Pick<
  DiceRollPrivacyState,
  "getDiceRollPrivacy" | "setRollToPrivacy" | "setHasSeenDiceContainer"
> = {
  getDiceRollPrivacy: (userId: number): DiceRollPrivacy | undefined =>
    useDiceRollPrivacyStore.getState()[userId],
  setRollToPrivacy: (userId: number, migrationValue?: RollTo): void => {
    const state = useDiceRollPrivacyStore.getState();
    const currentPrivacy = state.getDiceRollPrivacy(userId);
    const newRollTo =
      migrationValue || currentPrivacy?.rollTo === RollTos.All
        ? RollTos.Self
        : RollTos.All;

    useDiceRollPrivacyStore.setState({
      ...state,
      [userId]: {
        ...currentPrivacy,
        rollTo: newRollTo,
      },
    });
  },
  setHasSeenDiceContainer: (userId: number): void => {
    const state = useDiceRollPrivacyStore.getState();
    const currentPrivacy = state.getDiceRollPrivacy(userId);

    useDiceRollPrivacyStore.setState({
      ...state,
      [userId]: {
        ...currentPrivacy,
        hasSeenDiceContainer: true,
      },
    });
  },
};

export const useDiceRollPrivacyStore = create<DiceRollPrivacyState>()(
  persist(
    () => ({
      ...diceRollPrivacyFns,
    }),
    {
      name: "diceRollPrivacy",
    },
  ),
);
